import { Theme } from 'react-select';
import theme from './defaultTheme.module.scss';
import { defaultSelectStyles } from '../questionnaire/inputs/SelectInput/SelectInput';
import lazyLoadSVG from '../../utilities/lazyLoadSVG';

export enum KnownThemeImages {
	exclamationTriangle = 'exclamationTriangle',
	exclamationCircle = 'exclamationCircle',
	idBack = 'idBack',
	idFront = 'idFront',
	documentSelectIdFront = 'documentSelectIdFront',
	documentSelectPassportCover = 'documentSelectPassportCover',
	loadingBackImage = 'loadingBackImage',
	loadingIndicator = 'loadingIndicator',
	passportCover = 'passportCover',
	pinCode = 'pinCode',
	qrCode = 'qrCode',
	selfie = 'selfie',
	success = 'success',
	tooltipIcon = 'tooltipIcon',
	step1 = 'step1',
	step2 = 'step2',
	step3 = 'step3',
	idFrame = 'idFrame',
	selfieFrame = 'selfieFrame',
	mobileSelfieFrame = 'mobileSelfieFrame',
	idFrontExample = 'idFrontExample',
	idBackExample = 'idBackExample',
	selfieExample = 'selfieExample',
	passportCoverExample = 'passportCoverExample',
	add = 'add',
	check = 'check',
	youAreDone = 'youAreDone',
	failure = 'failure',
	continueInApp = 'continueInApp',
	appStore = 'appStore',
	googlePlay = 'googlePlay',
	google = 'google',
	apple = 'apple',
	close = 'close',
	passportIcon = 'passportIcon',
	idIcon = 'idIcon',
	residencePermitIcon = 'residencePermitIcon',
	residencePermitFront = 'residencePermitFront',
	residencePermitBack = 'residencePermitBack',
	driversLicenceIcon = 'driversLicenceIcon',
	driversLicenceFront = 'driversLicenceFront',
	driversLicenceBack = 'driversLicenceBack',
	warningTriangle = 'warningTriangle',
	copy = 'copy',
	underReview = 'underReview'
}

const selectInputTheme: Partial<Theme> = {
	colors: {
		primary: '#254098',
		primary75: '#6276b8',
		primary50: '#6276b8',
		primary25: '#e8e9ec'
	}
};

export default {
	styles: theme,
	selectInput: {
		styles: defaultSelectStyles,
		theme: selectInputTheme
	},
	images: {
		exclamationTriangle: lazyLoadSVG(() =>
			import('../../images/exclamation_triangle.svg').then(mod => mod.ReactComponent)
		),
		exclamationCircle: lazyLoadSVG(() =>
			import('../../images/exclamation_circle.svg').then(m => m.ReactComponent)
		),
		idBack: lazyLoadSVG(() => import('../../images/id_back.svg').then(m => m.ReactComponent)),
		idFront: lazyLoadSVG(() => import('../../images/id_front.svg').then(m => m.ReactComponent)),
		documentSelectIdFront: lazyLoadSVG(() =>
			import('../../images/id_front.svg').then(m => m.ReactComponent)
		),
		documentSelectPassportCover: lazyLoadSVG(() =>
			import('../../images/passport_cover.svg').then(m => m.ReactComponent)
		),
		loadingBackImage: lazyLoadSVG(() =>
			import('../../images/id_back.svg').then(m => m.ReactComponent)
		),
		loadingIndicator: lazyLoadSVG(() =>
			import('../../images/magnifying_glass.svg').then(m => m.ReactComponent)
		),
		passportCover: lazyLoadSVG(() =>
			import('../../images/passport_cover.svg').then(m => m.ReactComponent)
		),
		pinCode: lazyLoadSVG(() => import('../../images/pin.svg').then(m => m.ReactComponent)),
		qrCode: lazyLoadSVG(() => import('../../images/qr.svg').then(m => m.ReactComponent)),
		selfie: lazyLoadSVG(() => import('../../images/selfie.svg').then(m => m.ReactComponent)),
		success: lazyLoadSVG(() => import('../../images/success.svg').then(m => m.ReactComponent)),
		tooltipIcon: lazyLoadSVG(() =>
			import('../../images/tooltip.svg').then(m => m.ReactComponent)
		),
		step1: lazyLoadSVG(() =>
			import('../../images/Bankera/step1.svg').then(m => m.ReactComponent)
		),
		step2: lazyLoadSVG(() =>
			import('../../images/Bankera/step2.svg').then(m => m.ReactComponent)
		),
		step3: lazyLoadSVG(() =>
			import('../../images/Bankera/step3.svg').then(m => m.ReactComponent)
		),
		idFrame: lazyLoadSVG(() => import('../../images/id_frame.svg').then(m => m.ReactComponent)),
		selfieFrame: lazyLoadSVG(() =>
			import('../../images/selfie_frame.svg').then(m => m.ReactComponent)
		),
		mobileSelfieFrame: lazyLoadSVG(() =>
			import('../../images/selfie_frame_mobile.svg').then(m => m.ReactComponent)
		),
		selfieExample: lazyLoadSVG(() =>
			import('../../images/selfie_new.svg').then(m => m.ReactComponent)
		),
		idFrontExample: lazyLoadSVG(() =>
			import('../../images/id_card_front.svg').then(m => m.ReactComponent)
		),
		idBackExample: lazyLoadSVG(() =>
			import('../../images/id_card_back.svg').then(m => m.ReactComponent)
		),
		passportCoverExample: lazyLoadSVG(() =>
			import('../../images/passport_front_new.svg').then(m => m.ReactComponent)
		),
		add: lazyLoadSVG(() => import('../../images/Bankera/add.svg').then(m => m.ReactComponent)),
		check: lazyLoadSVG(() => import('../../images/check.svg').then(m => m.ReactComponent)),
		youAreDone: lazyLoadSVG(() =>
			import('../../images/youAreDone.svg').then(m => m.ReactComponent)
		),
		failure: undefined,
		continueInApp: lazyLoadSVG(() =>
			import('../../images/continueInApp.svg').then(m => m.ReactComponent)
		),
		appStore: lazyLoadSVG(() =>
			import('../../images/appStore.svg').then(m => m.ReactComponent)
		),
		googlePlay: lazyLoadSVG(() =>
			import('../../images/googlePlay.svg').then(m => m.ReactComponent)
		),
		google: lazyLoadSVG(() =>
			import('../../images/google_play.svg').then(m => m.ReactComponent)
		),
		apple: lazyLoadSVG(() => import('../../images/apple.svg').then(m => m.ReactComponent)),
		close: lazyLoadSVG(() => import('../../images/close.svg').then(m => m.ReactComponent)),
		passportIcon: lazyLoadSVG(() =>
			import('../../images/passport_document.svg').then(m => m.ReactComponent)
		),
		idIcon: lazyLoadSVG(() =>
			import('../../images/id_document.svg').then(m => m.ReactComponent)
		),
		residencePermitIcon: lazyLoadSVG(() =>
			import('../../images/residence_permit_document.svg').then(m => m.ReactComponent)
		),
		residencePermitFront: lazyLoadSVG(() =>
			import('../../images/residence_permit_front.svg').then(m => m.ReactComponent)
		),
		residencePermitBack: lazyLoadSVG(() =>
			import('../../images/residence_permit_back.svg').then(m => m.ReactComponent)
		),
		driversLicenceIcon: lazyLoadSVG(() =>
			import('../../images/drivers_licence_document.svg').then(m => m.ReactComponent)
		),
		driversLicenceFront: lazyLoadSVG(() =>
			import('../../images/drivers_licence_front.svg').then(m => m.ReactComponent)
		),
		driversLicenceBack: lazyLoadSVG(() =>
			import('../../images/drivers_licence_back.svg').then(m => m.ReactComponent)
		),
		warningTriangle: lazyLoadSVG(() =>
			import('../../images/warningTriangle.svg').then(m => m.ReactComponent)
		),
		copy: lazyLoadSVG(() => import('../../images/copy.svg').then(m => m.ReactComponent)),
		underReview: lazyLoadSVG(() =>
			import('../../images/youAreDone.svg').then(m => m.ReactComponent)
		)
	},
	key: null
};
